import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Scoreboard from './component/scoreboard/Scoreboard';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import CenterMonitor from './component/centerMonitor/CenterMonitor';
import Standing from './component/standing/Standing';
import App from './App';
import GameMonitor from './component/gameMonitor/GameMonitor';
import Setup from './component/setup/Setup';

const router = createBrowserRouter([
    { path: '/', element: <App /> },
    { path: '/scoreboard/:side', element: <Scoreboard /> },
    { path: '/monitor/center', element: <CenterMonitor /> },
    { path: '/monitor/:side', element: <GameMonitor /> },
    { path: '/standing', element: <Standing /> },
    { path: '/setup', element: <Setup /> },
]);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
